import React, {Component} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../public/css/barri.css';

import SectionPrivacy from "./SectionQuisqueyanaPolicy/SectionPrivacy/SectionPrivacy.js";
import SectionTerms from "./SectionQuisqueyanaPolicy/SectionTerms/SectionTerms.js";
import SectionESign from "./SectionQuisqueyanaPolicy/SectioneESign/SectionESign.js";
import SectionUserAgreement from "./SectionQuisqueyanaPolicy/SectionUserAgreement/SectionUserAgreement.js";
import SectionLegalNotices from "./SectionQuisqueyanaPolicy/SectionLegalNotices/SectionLegalNotices.js";
import SectionFileComplaint from "./SectionQuisqueyanaPolicy/SectionFileComplaint/SectionFileComplaint.js";
import QuisqueyanaPolicyMenu from "./SectionQuisqueyanaPolicy/QuisqueyanaPolicyMenu/QuisqueyanaPolicyMenu.js";

export default class SectionQuisqueyanaPolicy extends Component
{
  constructor(props) {
    super(props);
    this.state = {
      locale: "es",
      expandAll: true 
    };
  }

  switchLanguage(){
    this.setState({
      locale: this.state.locale == 'en' ? 'es' : 'en'
    })
  }

  switchExpand(){
    this.setState({
      expandAll: this.state.expandAll ? false : true
    })
  }

  render(){

    let section = null;
    switch (this.props.route.section) {
      case "privacy":
        section = <SectionPrivacy locale={this.state.locale} />
      break;
      case "terms":
        section = <SectionTerms locale={this.state.locale} />
      break;
      case "esign":
        section = <SectionESign locale={this.state.locale} />
      break;
      case "agreement":
        section = <SectionUserAgreement locale={this.state.locale} />
      break;
      case "complaint":
        section = <SectionFileComplaint locale={this.state.locale} />
      break;
      case "notices":
        section = <SectionLegalNotices locale={this.state.locale} />
      break;
      default:
        break;
    };

    return <section id="quisqueyanaPolicySection">

  
      <QuisqueyanaPolicyMenu locale={this.state.locale} switchLanguage={this.switchLanguage.bind(this)} expandAll={this.state.expandAll} switchExpand={this.switchExpand.bind(this)}  section={this.props.route.section}/>
  
      <div className="container">
  
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
            {section}
          </div>
        </div>
      </div>
    </section>
  }

  
  }


// WEBPACK FOOTER //
// ./js/SectionQuisqueyanaPolicy.js